import { createFileRoute } from "@tanstack/react-router";
import { EstruturaDadosPage } from "@/paginas/pg_database/database-visualizar-estruturas";

export const Route = createFileRoute("/_authenticated/database-visualizar-estruturas")({
  head: () => ({
    meta: [
      { title: "Estrutura das tabelas — Milky Moo Palmares" },
      { name: "description", content: "Estrutura das tabelas do banco (dev)." },
      { property: "og:title", content: "Estrutura das tabelas — Milky Moo Palmares" },
      { property: "og:description", content: "Estrutura das tabelas do banco (dev)." },
    ],
  }),
  component: EstruturaDadosPage,
});
